/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { addOperator } from "../../../../api/Api";
import Swal from "sweetalert2";
import "./addOperator.css";
const AddOperator = ({
  setAddProductModal,
  getAllData,
  operatorData,
  countryId,
}) => {
  // State for multiple operators
  const [operators, setOperators] = useState([
    { operatorName: "", currency: "" }
  ]);

  // Add new operator fields
  const handleAddOperator = () => {
    setOperators([...operators, { operatorName: "", currency: "" }]);
  };

  // Handle input change
  const handleInputChange = (index, field, value) => {
    const newOperators = [...operators];
    newOperators[index][field] = value;
    setOperators(newOperators);
  };

  // Remove operator fields
  const handleRemoveOperator = (index) => {
    if (operators.length > 1) {
      const newOperators = operators.filter((_, i) => i !== index);
      setOperators(newOperators);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate inputs
    const hasEmptyFields = operators.some(
      op => !op.operatorName.trim() || !op.currency.trim()
    );

    if (hasEmptyFields) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please fill all operator fields"
      });
      return;
    }

    try {
      const payload = {
        id: countryId,
        operators: operators
      };

      const response = await addOperator(payload);
      
      if (response?.statusDescription?.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Operators added successfully"
        }).then(() => {
          setAddProductModal(false);
          getAllData();
        });
      } else {
        throw new Error(response?.statusDescription?.description || "Failed to add operators");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Failed to add operators"
      });
    }
  };

  return (
    <form className="form-horizontal" onSubmit={handleSubmit}>
        {operators.map((operator, index) => (
          <div key={index} className="row mb-3">
            <div className="form-group col-md-4 price">
              {/* <div className="form-group"> */}
                {/* <label className="control-label">Operator Name</label> */}
                <label className="">Operator Name</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Operator Name"
                  value={operator.operatorName}
                  onChange={(e) => handleInputChange(index, "operatorName", e.target.value)}
                />
              {/* </div> */}
            </div>
            <div className="col-md-4 form-group validity">
              {/* <div className="form-group"> */}
                <label className="">Currency</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Currency"
                  value={operator.currency}
                  onChange={(e) => handleInputChange(index, "currency", e.target.value)}
                />
              {/* </div> */}
            </div>
            <div className="col-md-4 d-flex align-items-center plus_minus">
              {operators.length > 1 && (
                <button
                  type="button"
                  className="btn btn-danger py-1 mt-2 minus-1"
                  onClick={() => handleRemoveOperator(index)}
                >
                  <i className="fas fa-minus"></i>
                </button>
              )}
              {index === operators.length - 1 && (
                <button
                  type="button"
                  className="btn btn-primary py-1 mt-2 plus-1"
                  onClick={handleAddOperator}
                >
                  <i className="fas fa-plus"></i>
                </button>
              )}
            </div>
          </div>
        ))}
        
        {/* <div className="row mt-4"> */}
          <div className="modal-footer pb-0 border-0 d-flex justify-content-between px-0 mx-0 buttons_divs">
           
            <button
              type="button"
              className="btn btn-secondary m-0"
              onClick={() => setAddProductModal(false)}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary m-0">
              Submit
            </button>
          </div>
        {/* </div> */}
    </form>
  );
};

export default AddOperator;